import React from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

interface Props {
  value: any;
  label: string;
  options: any[];
  onChange: (event: any) => void;
  isDisabled?: boolean;
}

const AVDropdown = ({
  value,
  label,
  options,
  onChange,
  isDisabled = false,
}: Props) => {
  return (
    <FormControl fullWidth>
      <InputLabel id={`${label}-label`}>{label}</InputLabel>

      <Select
        labelId={`${label}-label`}
        value={value}
        label={label}
        onChange={onChange}
        disabled={isDisabled}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200,
            },
          },
        }}
      >
        {options?.map((option) => (
          <MenuItem
            key={option?.name || option?.id || option?.value}
            value={option?.name || option?.id || option?.value}
          >
            {option?.loc || option?.title || option?.label || option?.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AVDropdown;
